import { WatchLater as WatchLaterScreen } from "@/app/modules/Playlists";
import { ErrorPage } from "@/components";
import { useAppProperties } from "@/hooks";

export const WatchLater = () => {
  const { showWatchlist, isLoading } = useAppProperties();

  if (!isLoading && !showWatchlist) {
    return <ErrorPage code={404} />;
  }
  return <WatchLaterScreen />;
};
